type Event = {
  target: HTMLElement | Window;
  e: keyof DocumentEventMap;
  c: (e: unknown) => void;
};

export default class EventUtils {
  protected events: Event[] = [];

  constructor() {
    this.events = [];

    this.addEventListener = this.addEventListener.bind(this);
    this.removeEventListeners = this.removeEventListeners.bind(this);
  }

  public addEventListener(
    event: keyof DocumentEventMap,
    callback: (e: unknown) => void,
    target: HTMLElement | Window = window,
  ): void {
    this.events.push({ e: event, c: callback, target });

    const i = this.events.length - 1;

    target.addEventListener(this.events[i].e, this.events[i].c);
  }

  public removeEventListener(eventToRemove: keyof DocumentEventMap, target: HTMLElement | Window = window): void {
    const event: Event | undefined = this.events.find((e) => e.e === eventToRemove);
    if (event) {
      target.removeEventListener(event.e, event.c);
    }
  }

  public removeEventListeners(): void {
    this.events.forEach((event) => {
      event.target.removeEventListener(event.e, event.c);
    });
    this.events = [];
  }
}
